<template>
  <div style="display: none;">
    <div ref="content">
      <slot name="marker" />
    </div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";

export default {
  name: "MglMarker",
  inject: ["map"],
  props: {
    coordinates: {
      type: Array,
      required: true,
    },
    color: {
      type: String,
      default: undefined,
    },
    anchor: {
      type: String,
      default: "center",
    },
    offset: {
      type: [Array, Object],
      default: undefined,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      marker: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.createMarker();
    });
  },
  methods: {
    createMarker() {
      if (!this.map) return;

      const options = {
        draggable: this.draggable,
      };

      if (this.color) {
        options.color = this.color;
      }

      if (this.offset) {
        options.offset = this.offset;
      }

      // Use custom content if the marker slot has content
      const slotContent = this.$refs.content;
      if (slotContent && slotContent.innerHTML.trim()) {
        options.element = slotContent;
        slotContent.style.display = "";
      }

      this.marker = new mapboxgl.Marker(options)
        .setLngLat(this.coordinates)
        .addTo(this.map);

      // Forward events
      const el = this.marker.getElement();
      el.addEventListener("mouseenter", (e) => this.$emit("mouseenter", e));
      el.addEventListener("mouseleave", (e) => this.$emit("mouseleave", e));
      el.addEventListener("click", (e) => this.$emit("click", e));

      if (this.draggable) {
        this.marker.on("dragend", () => {
          const lngLat = this.marker.getLngLat();
          this.$emit("update:coordinates", [lngLat.lng, lngLat.lat]);
          this.$emit("dragend", { lngLat });
        });
      }
    },
    removeMarker() {
      if (this.marker) {
        this.marker.remove();
        this.marker = null;
      }
    },
  },
  watch: {
    coordinates(val) {
      if (this.marker && val) {
        this.marker.setLngLat(val);
      }
    },
  },
  beforeDestroy() {
    this.removeMarker();
  },
};
</script>
